// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"xc qo","whiteTheme":"xd","markdownWrapper":"xe"};